import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"calculator-1"},"children":[{"tag":"path","attrs":{"id":"fil1","fill":"#fff","d":"M19 21V9H5V21H19Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M5 3H19V9H5V3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M19 3V21H5V3M19 3H5M19 3V9H5V3M14 9L14 21M10 9L10 21M5 13H19M5 17H19","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Calculator1 = Vue.extend<IconProps>({
  name: 'Calculator1Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'calculator-1',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Calculator1;
